<template>
  <div class="carousel-item__cta">
    <sc-link
      v-if="fields && fields.cta && fields.cta.value && fields.cta.value.text"
      :field="fields.cta"
    />
  </div>
</template>

<script>
import { Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-CTA-Carousel-Item-CTA',
  components: {
    ScLink: Link
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
.carousel-item__cta {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;

  a {
    display: inline-block;
    font-size: 1.6rem;
    line-height: 2rem;
  }

  // Editor
  &.scEnabledChrome {
    justify-content: left;
  }
}
</style>
